import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import DocumentFilterView from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/DocumentFilterView';
import documentFiltersSignal, {
	setDocumentFilters,
} from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/Signals/documentFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';

/** Filters in effect for this dossier: a stored value set for another dossier is replaced by a default. */
const useEffectiveDocumentFilters = (subject: SubjectAddress): DocumentFilterView => {
	const stored = useSignalValue(documentFiltersSignal);

	const effective = React.useMemo(() => {
		return stored.belongsTo(subject) ? stored : DocumentFilterView.createDefault(subject);
	}, [stored, subject]);

	React.useEffect(() => {
		if (!stored.belongsTo(subject)) {
			setDocumentFilters(effective);
		}
	}, [stored, effective, subject]);

	return effective;
};

export default useEffectiveDocumentFilters;
